<div class="container">
    <mat-label>{{title}}</mat-label>
    <input type="text" value="{{parameter?.value}}" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete">
        @for (option of parameter?.detected; track option) {
        <mat-option [value]="option">{{option.value}} ({{option.source}})</mat-option>
        }
    </mat-autocomplete>
</div>